module.exports = __webpack_public_path__ + "img/puzzle5.jpg";